module.exports = __webpack_public_path__ + "img/b3-1.20ddb56.png";